export default "__VITE_ASSET__DE8G3oOG__"